// The Paperless bearer token and the loaded business list are reused across clients, so they are
// persisted locally and prefilled instead of forcing the user to paste the token each time.

export const PAPERLESS_SETTINGS_KEY = 'paperlessImportSettings';
export const PAPERLESS_USERS_KEY = 'paperlessImportClients';

export const loadPaperlessSettings = () => {
    try {
        const raw = localStorage.getItem(PAPERLESS_SETTINGS_KEY);
        const parsed = raw ? JSON.parse(raw) : {};
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
};

// Merge-persist so a partial save never clears the fields it does not own.
export const savePaperlessSettings = (patch) => {
    try {
        const current = loadPaperlessSettings();
        localStorage.setItem(
            PAPERLESS_SETTINGS_KEY,
            JSON.stringify({ ...current, ...patch })
        );
    } catch {
        /* ignore storage errors (private mode, quota, etc.) */
    }
};

export const loadPaperlessUsersCache = () => {
    try {
        const raw = localStorage.getItem(PAPERLESS_USERS_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

export const savePaperlessUsersCache = (users) => {
    if (!Array.isArray(users) || !users.length) return;
    try {
        localStorage.setItem(PAPERLESS_USERS_KEY, JSON.stringify(users));
    } catch {
        /* ignore storage errors */
    }
};

// Find the Paperless business whose VAT number matches the given accounting caseId.
export const matchPaperlessUserByCaseId = (users, caseId) => {
    if (!Array.isArray(users) || !users.length) return null;
    const normalizedCaseId = caseId != null ? String(caseId).trim() : '';
    if (!normalizedCaseId) return null;
    return users.find((u) => String(u?.companyId ?? '').trim() === normalizedCaseId) || null;
};

// Paperless expresses a period as "YYMM". The modal's month inputs are native <input type="month">
// ("YYYY-MM"), so both directions are needed.
export const monthInputToPeriod = (monthValue) => {
    const match = /^(\d{4})-(\d{2})$/.exec(String(monthValue ?? '').trim());
    if (!match) return '';
    return `${match[1].slice(2)}${match[2]}`;
};

export const periodToMonthInput = (period) => {
    const trimmed = String(period ?? '').trim();
    if (!/^\d{4}$/.test(trimmed)) return '';
    return `20${trimmed.slice(0, 2)}-${trimmed.slice(2)}`;
};

export const currentMonthInput = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
};
